import React from 'react'
import styled from 'styled-components'
import Tabs, { TabsProps } from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { StyledTabProps } from './types'
import { Flex } from '../Flex'

const MainWrapper = styled(Flex)<{ withBackground: boolean }>`
  height: 32px;
  width: 100%;
  border: ${({ theme, withBackground }) => (withBackground ? 'none' : `1px solid ${theme.colors.gray7}`)};
  background: ${({ theme, withBackground }) => (withBackground ? theme.colors.gray10 : 'transparent')};
  border-radius: 8px;
  justify-content: center;
  align-items: center;
`

const StyledTabs = styled((props: TabsProps) => <Tabs {...props} />)(({ theme }) => ({
  width: '100%',
  '& .MuiTabs-flexContainer': {
    borderRadius: 8
  },
  '& .MuiTab-root': {
    fontFamily: 'SpaceGroteskMedium',
    fontWeight: '500',
    color: theme.colors.text,
    textTransform: 'none',
    padding: 0,
    alignItems: 'center',
    flex: 1,
    maxWidth: 'unset',
    letterSpacing: 0
  },
  '& .MuiTabs-indicator': {
    height: 34,
    borderRadius: 8,
    bottom: 7,
    backgroundColor: theme.colors.gray7
  },
  '& .Mui-disabled': {
    color: `${theme.colors.gray3} !important`
  }
}))

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const StyledTab = styled(({ customPadding, ...props }: StyledTabProps) => <Tab disableRipple {...props} />)(
  ({ theme, customPadding }) => ({
    width: 'max-content !important',
    maxWidth: 'unset !important',
    height: '34px !important',
    padding: customPadding || '0px 16px !important',
    zIndex: 2,
    '&:hover': {
      color: `${theme.colors.gray3} !important`,
      opacity: 1
    },
    '&.Mui-selected': {
      color: `${theme.colors.text} !important`
    },

    '&.Mui-focusVisible': {
      backgroundColor: 'none'
    },

    [theme.mediaQueries.mobile]: {
      padding: customPadding || '0px 16px !important'
    }
  })
)

interface RoundTabsProps {
  tabs: StyledTabProps[]
  onChange: (event: React.SyntheticEvent, newValue: number) => void
  value: number
  withBackground?: boolean
  customPadding?: string
}

const RoundTabs: React.FC<RoundTabsProps> = ({ tabs, onChange, value, withBackground = false, customPadding }) => {
  return (
    <MainWrapper {...{ withBackground }}>
      <StyledTabs value={value} onChange={onChange} variant="scrollable">
        {tabs.map((tab, index) => (
          <StyledTab
            {...{ customPadding }}
            disabled={tab.disabled}
            value={tab.value}
            label={
              <Flex>
                {tab.label}
                {tab?.tag}
              </Flex>
            }
            key={index}
            sx={{ minWidth: 'max-content' }}
          />
        ))}
      </StyledTabs>
    </MainWrapper>
  )
}

export default RoundTabs
